module.exports = __webpack_public_path__ + "img/header.3fc49be5.png";